import { List } from 'immutable';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { paymentsGridGetHeadersAction } from 'domain/payments/actions';
import Api from 'domain/api';
import * as adapters from 'domain/documents/adapters';

const useFetchGridColumnDefs = (params: Record<string, unknown>) => {
  const dispatch = useDispatch();

  const [columnDefs, setColumnDefs] = useState<any[]>([]);
  const [isBusy, setIsBusy] = useState(true);

  const fetchGridColumnHeaders = useCallback(
    async () =>
      Api.getPaymentsGridHeaders({
        params,
      }),
    [params],
  );

  useEffect(() => {
    setIsBusy(true);
    dispatch(paymentsGridGetHeadersAction());

    fetchGridColumnHeaders()
      .then(({ data }) => {
        const columns = adapters.gridHeadersListAdapter(data);

        setColumnDefs(columns.toJS());

        dispatch({
          type: paymentsGridGetHeadersAction.success,
          payload: columns,
        });
      })
      .catch(() => {
        dispatch({
          type: paymentsGridGetHeadersAction.failure,
          payload: List(),
        });

        // TODO: ag-grid doLogout Action
      })
      .finally(() => {
        setIsBusy(false);
      });
  }, [fetchGridColumnHeaders, dispatch]);

  return {
    rawColumnDefs: columnDefs,
    rawColumnDefsIsBusy: isBusy,
    setRawColumnDefs: setColumnDefs,
  };
};

export default useFetchGridColumnDefs;
